import { render, staticRenderFns } from "./HomeSideMenu.vue?vue&type=template&id=27a7e251&scoped=true"
import script from "./HomeSideMenu.vue?vue&type=script&lang=js"
export * from "./HomeSideMenu.vue?vue&type=script&lang=js"
import style0 from "./HomeSideMenu.vue?vue&type=style&index=0&id=27a7e251&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a7e251",
  null
  
)

export default component.exports